import React, { useCallback } from "react";
import {
  Datagrid,
  DatagridConfigurable,
  DateField,
  FunctionField,
  List,
  SelectField,
  SelectInput,
  TextField,
  useRedirect,
  useTranslate,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";

import { PendingTask } from "../api/pending_tasks";
import { createPendingTaskLink } from "../utils/url";
import { createTaskKeys } from "../components/choices";
import { ListActions } from "../components/list_actions";

const PendingTaskFilter = [<SelectInput key="task_key" source="task_key" choices={createTaskKeys()} alwaysOn />];

function getDealId(record: PendingTask) {
  if (record.deal_id) {
    return "A" + record.deal_id;
  } else if (record.amend_id) {
    return "A" + record.amend_id;
  } else if (record.spot_contract_deal_id) {
    return "S" + record.spot_contract_deal_id;
  } else if (record.spot_contract_amend_id) {
    return "S" + record.spot_contract_amend_id;
  }
}

export const PendingTaskList = (props: any) => {
  const redirect = useRedirect();
  const translate = useTranslate();
  const preferenceKey = "pending_tasks";
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  const rowClick = useCallback(
    (id: number, basePath: string, record: PendingTask) => {
      const path = createPendingTaskLink(record);
      redirect(path);
    },
    [redirect]
  );

  return (
    <List
      {...props}
      filters={PendingTaskFilter}
      bulkActionButtons={false}
      exporter={false}
      sort={{ field: "deadline", order: "ASC" }}
      actions={isMobile ? false : <ListActions preferenceKey={preferenceKey} />}
    >
      {isMobile ? (
        <Datagrid bulkActionButtons={false} rowClick={rowClick}>
          <FunctionField source="deal_id" render={getDealId} sortable={false} />
          <DateField source="deadline" />
          <FunctionField
            source="mobile_task_key_and_trading_partner"
            sortable={false}
            render={(record: PendingTask) => (
              <Box sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
                <Box>{translate(`commons.task_keys.${record.task_key}`)}</Box>
                <Box>{record.trading_partner}</Box>
              </Box>
            )}
          />
        </Datagrid>
      ) : (
        <DatagridConfigurable bulkActionButtons={false} preferenceKey={preferenceKey} omit={["id"]} rowClick={rowClick}>
          <TextField source="id" />
          <FunctionField source="deal_id" render={getDealId} sortable={false} />
          <SelectField source="task_key" choices={createTaskKeys()} sortable={false} />
          <DateField source="deadline" />
          <TextField source="trading_partner" sortable={false} />
          <TextField source="description" sortable={false} />
        </DatagridConfigurable>
      )}
    </List>
  );
};
